import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Modal, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ButtonComponent, AnchorComponent } from "../elements";

export default function UsersTableComponent({ thead, tbody }) {
    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [userIdToDelete, setUserIdToDelete] = useState(null);
    const [userData, setUserData] = useState("");
    const [editModal, setEditModal] = useState(false);
    const [blockModal, setBlockModal] = useState(false);

    useEffect(() => {
        setData(tbody);
    }, [tbody]);

    const handleCheckbox = (event) => {
        const { name, checked } = event.target;

        if (name === "allCheck") {
            const checkData = data?.map((item) => {
                return { ...item, isChecked: checked };
            });
            setData(checkData);
        } else {
            const checkData = data?.map((item) =>
                item.name === name ? { ...item, isChecked: checked } : item
            );
            setData(checkData);
        }
    };

    // Handle Delete
    const handleDelete = (id) => {
        setUserIdToDelete(id); // Store the ID to delete
        setBlockModal(true); // Show confirmation modal
    };

    const confirmDelete = () => {
        if (userIdToDelete !== null) {
            setData(data.filter(user => user.id !== userIdToDelete)); // Delete user
            setUserIdToDelete(null); // Reset state
        }
        setBlockModal(false); // Close modal
    };

    useEffect(() => {
        console.log("Updated Data in State:", data);
    }, [data]);

    return (
        <div className="mc-table-responsive">
            <table className="mc-table">
                <thead className="mc-table-head primary">
                    <tr>
                        <th>
                            <div className="mc-table-check">
                                <input
                                    type="checkbox"
                                    name="allCheck"
                                    checked={data?.filter((item) => item?.isChecked !== true).length < 1}
                                    onChange={handleCheckbox}
                                />
                                <p>uid</p>
                            </div>
                        </th>
                        {thead.map((item, index) => (
                            <th key={index}>{item}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data?.map((item, index) => (
                        <tr key={index}>
                            <td title="id">
                                <div className="mc-table-check">
                                    <input
                                        type="checkbox"
                                        name={item?.name}
                                        checked={item?.isChecked || false}
                                        onChange={handleCheckbox}
                                    />
                                    <p>#{index + 1}</p>
                                </div>
                            </td>
                            <td title={item?.name}>
                                <div className="mc-table-profile">
                                    <p>{item?.name}</p>
                                </div>
                            </td>
                            <td title={item?.role}>
                                <div className="mc-table-icon role">
                                    {item?.role?.text === "vendor" && (
                                        <i className="material-icons yellow">{item?.role?.icon}</i>
                                    )}
                                    {item?.role?.text === "member" && (
                                        <i className="material-icons green">{item?.role?.icon}</i>
                                    )}
                                    {item?.role?.text === "admin" && (
                                        <i className="material-icons purple">{item?.role?.icon}</i>
                                    )}
                                    {item?.role?.text === "founder" && (
                                        <i className="material-icons blue">{item?.role?.icon}</i>
                                    )}
                                    <span>{item?.type_id}</span>
                                </div>
                            </td>
                            <td title={item?.email}>{item?.email}</td>
                            <td title={item?.password}>{item?.roles}</td>
                            <td title={item?.phone}>{item?.origin}</td>
                            <td title={item?.created}>
                                <img src={item?.signature?.preview} height={100} width={100} alt="User" />
                            </td>
                            <td>
                                <div className="mc-table-action">
                                    <AnchorComponent to="/user-profile" title="View" className="material-icons view">
                                        {item?.action?.view}
                                    </AnchorComponent>
                                    <ButtonComponent
                                        title="Edit"
                                        className="material-icons edit"
                                        onClick={() =>
                                            navigate(`/edit-user/${item}`, { state: { userData: item, index } })
                                        }
                                    >
                                        {item?.action?.edit}
                                    </ButtonComponent>
                                    <ButtonComponent
                                        title="Block"
                                        className="material-icons block"
                                        onClick={() => handleDelete(item.id)} // Show confirmation modal
                                    >
                                        {item?.action?.delete}
                                    </ButtonComponent>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Edit Modal */}
            <Modal show={editModal} onHide={() => setEditModal(false)}>
                <div className="mc-user-modal">
                    <img src={userData.src} alt={userData?.alt} />
                    <h4>{userData?.name}</h4>
                    <p>{userData?.email}</p>
                    <Form.Group className="form-group inline mb-4">
                        <Form.Label>{t("role")}</Form.Label>
                        <Form.Select>
                            <option value="founder">{t("founder")}</option>
                            <option value="admin">{t("admin")}</option>
                            <option value="member">{t("member")}</option>
                            <option value="client">{t("client")}</option>
                            <option value="vendor">{t("vendor")}</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="form-group inline">
                        <Form.Label>{t("status")}</Form.Label>
                        <Form.Select>
                            <option value="approved">{t("approved")}</option>
                            <option value="pending">{t("pending")}</option>
                            <option value="blocked">{t("blocked")}</option>
                        </Form.Select>
                    </Form.Group>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setEditModal(false)}>
                            {t("close_popup")}
                        </ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-success" onClick={() => setEditModal(false)}>
                            {t("save_changes")}
                        </ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>

            {/* Block (Delete) Modal */}
            <Modal show={blockModal} onHide={() => setBlockModal(false)}>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>{t("are_you_sure")}</h3>
                    <p>{t("want_to_delete_this_user")}</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={() => setBlockModal(false)}>
                            {t("close")}
                        </ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={confirmDelete}>
                            {t("delete")}
                        </ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    );
}
